import { Outlet } from "react-router-dom";

import { TelaComAbas } from "@/shared/components/tela-com-abas";
import type { RecursosViewModel } from "./types-recursos";

/** Casca de Recursos (Figma 5212:130632): título, abas Profissionais e Carga de Trabalho e a aba da rota. */
export function RecursosView({ titulo, abas, abasLabel, mobileQuery }: RecursosViewModel) {
  return (
    <TelaComAbas
      titulo={titulo}
      abas={abas}
      abasLabel={abasLabel}
      mobileQuery={mobileQuery}
      variante="janela"
      testId="recursos-screen"
      headerTestId="recursos-header"
      ocultarCabecalhoNaImpressao
    >
      <Outlet />
    </TelaComAbas>
  );
}
